import { defineMessages } from 'react-intl';

export default defineMessages({
    inputTooltip: {
        id: '_.select_amount_with_slider.tooltip',
        defaultMessage: `If you don't take the full {amount} today, you've got until {date} to come back for the rest.`
    },
    cta: {
        id: '_.multi_loan_dashboard.approved_offer.drawdown_cta',
        defaultMessage: 'Continue with {amount}'
    },
    CTAinfo: {
        id: '_.multi_loan_dashboard.cta_info_text',
        defaultMessage:
            'Before we can send funds to your account, we need you to complete a few final steps. Click "Continue" to get started.'
    },
    CTAdisabled: {
        id: '_.multi_loan_dashboard.cta_disabled_text',
        defaultMessage:
            'Maximum available loan amount for the selected offer is {availableCash}. Select a new option or change the loan amount'
    },
    personalGuaranteedNotRequired: {
        id: '_.multi_loan_dashboard.personal_guarantee_not_required',
        defaultMessage: 'No personal guarantee required'
    }
});
